export default __webpack_public_path__ + "static/logolgbg2-9505f40bb9198e49846bc6314199b3df.png";